import { render, staticRenderFns } from "./CoreDeductionsTab.vue?vue&type=template&id=242f8afd"
import script from "./CoreDeductionsTab.ts?vue&type=script&lang=ts&external"
export * from "./CoreDeductionsTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports